export const DESKTOP_ITEMS_PER_ROW = 5;
export const TABLET_ITEMS_PER_ROW = 4;
export const MOBILE_ITEMS_PER_ROW = 2;

export const getUserRecommendationsItemsPerRow = (isMobile: boolean, isTablet: boolean): number => {
    if (isMobile) {
        return MOBILE_ITEMS_PER_ROW;
    }
    if (isTablet) {
        return TABLET_ITEMS_PER_ROW;
    }
    return DESKTOP_ITEMS_PER_ROW;
};
